// import moment from 'moment';

export const finishAuthentication = (token, userData, expires_at) => {

    // var cryptoVar = crypto.subtle;
    // const result = crypto.subtle.encrypt( {
    //     name: "AES-GCM "
    //   }, "logUserIn", userData);


    window.sessionStorage.setItem('msa_jwt', token);
    window.sessionStorage.setItem('msa_user_data', JSON.stringify(userData));
    // window.sessionStorage.setItem('msa_jwt_expire', JSON.stringify(expires_at));
    // console.log(userData)
    // localStorage.setItem('access_token', token);
    // localStorage.setItem('id', userData.id);
    // localStorage.setItem('expires_at', expires_at);
    // localStorage.setItem('email', userData.email);
};
export const updateUser = (userData) => {

    window.sessionStorage.setItem('msa_user_data', JSON.stringify(userData));
};

export const getToken = () => {
    let token = sessionStorage.getItem('msa_jwt');
    if (token) {
        return token;
    }
    return null;
};

export const getUserdata = () => {
    let userData = sessionStorage.getItem('msa_user_data');
    if (userData) {
        return JSON.parse(userData);
    }
    return null;
};

export const updateUserData = (userData) => {
    window.sessionStorage.setItem('msa_user_data', JSON.stringify(userData));
}

export const deleteToken = () => {
    window.sessionStorage.removeItem('msa_jwt');
    window.sessionStorage.removeItem('msa_user_data');
};

// export const isSessionExpired = () => {
//     // const jwt = window.sessionStorage.getItem('msa_jwt_expire');
//     if (!jwt) {
//         return true;
//     } else {
//         // return moment(JSON.parse(jwt)).isBefore(moment());
//     }
// };